<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :data="items.data"
      style="width: 100%"
      row-key="id"
      width="100%"
      @sort-change="handleSortChange"
    >

      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="80"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="invoiceReceiptReceives"
            :options="['settings']"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
          background
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="items.per_page"
          layout="total, prev, pager, next"
          :total="items.total"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        currentPage: 1,
        itemLoading: 0,
        currentSort: {
          prop: 'created_at',
          order: 'desc',
        },
      };
    },
    computed: {
      items() {
        return this.$store.getters['invoiceReceiptReceives/items'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['invoiceReceiptReceives/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeSale/loading'];
      },
    },

    async mounted() {
      this.$store.commit('representativeSale/setFilterString', '');
      this.$store.commit('representativeSale/setCurrentPage', this.currentPage);
      this.$store.commit('representativeSale/setSorting', this.currentSort);
      await this.$store.dispatch('invoiceReceiptReceives/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('invoiceReceiptReceives/setCurrentPage', val);
        this.$store.dispatch('invoiceReceiptReceives/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('invoiceReceiptReceives/setSorting', { prop, order });
          this.$store.dispatch('invoiceReceiptReceives/fetchAll');
        }
      },
    },
  };
</script>

